import React, {PropsWithChildren, useRef, useState} from "react";

type ResizableContainerProps = {
    firstDivContent: React.ReactNode;
    secondDivContent: React.ReactNode;
    initialWidth: number;
    onWidthChange?: (widthPercentage: number) => void;
    minWidth?: number;
};

export const ResizableContainer = ({
                                       firstDivContent,
                                       secondDivContent,
                                       initialWidth,
                                       onWidthChange,
                                       minWidth = 30
                                   }: PropsWithChildren<ResizableContainerProps>) => {
    const [div1Width, setDiv1Width] = useState(initialWidth);
    const newWidthRef = useRef<number>(div1Width);

    const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault();
        
        const startX = e.clientX;

        const handleMouseMove = (moveEvent: MouseEvent) => {
            const deltaX = moveEvent.clientX - startX;
            const newWidth = ((div1Width * window.innerWidth) / 100 + deltaX) / window.innerWidth * 100;

            if (newWidth > minWidth && newWidth < (100 - minWidth)) { // Prevent div1 from being too small or too large
                newWidthRef.current = newWidth;
                setDiv1Width(newWidth);
            }
        };

        const handleMouseUp = () => {
            if (onWidthChange) {
                onWidthChange(Math.round(newWidthRef.current));
            }
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    return (
        <div className="resizable-container d-flex">
            <div className="resizable-div-1" style={{width: `${div1Width}%`}}>
                {firstDivContent}
            </div>
            <div
                className="resizable-handle"
                onMouseDown={handleMouseDown}
            />
            <div className="resizable-div-2" style={{width: `${100 - div1Width}%`}}>
                {secondDivContent}
            </div>
        </div>
    );
};
